import { get } from 'lodash';
import addNodeToList from '../reducerUtils/addNodeToList';
import {
  getRevalidatedNodesAndGlobalErrors,
  mergePreviousNodesPerNode,
  getSurveyConfigForValidate,
  validateQuotaAndUpdateState,
} from '../utils';
import { LOGIC_MODE_KEYS } from '../constants';
import { setActiveNode } from './activeNode';
import { addQuestionRefIdCorrection } from '../reducer_utils';

export function duplicateMultipleQuestionsToQuestionnaire(state, action) {
  const {
    questions,
    originGroupRefId,
    direction,
    screenerTypesByQuestion = {},
  } = action.payload;
  let { originQuestionRefId } = action.payload;

  const nodes = get(state, 'surveyDetailsExtended.questions', []);
  const screeningQuestions = get(
    state,
    'surveyDetailsExtended.screeningQuestions',
    [],
  );
  const questionnaireEditVersion = get(
    state,
    'surveyDetailsExtended.questionnaireEditVersion',
  );

  let finalNodes = nodes;
  let finalQuestionnaireLogic = state.questionnaireLogic;
  let finalGlobalErrors = state.errors;
  let newActiveNode;

  questions.forEach((question, index) => {
    const clonedQuestion = { ...question };
    clonedQuestion.groupRefId = originGroupRefId;
    const shouldScroll = index === 0;
    // handle add screening question above a non screening question
    originQuestionRefId = addQuestionRefIdCorrection({
      refId: originQuestionRefId,
      isScreening: clonedQuestion.isScreening,
      screeningQuestions,
    });
    if (shouldScroll) {
      newActiveNode = clonedQuestion;
    }
    if (clonedQuestion.isScreening) {
      clonedQuestion.isScreenerActive = true;
    }
    // eslint-disable-next-line
    let { newNodes, newQuestionnaireLogic, globalErrors } = addNodeToList({
      nodes: finalNodes,
      node: clonedQuestion,
      screeningQuestions,
      refId: originQuestionRefId,
      errors: finalGlobalErrors,
      questionnaireLogic: finalQuestionnaireLogic,
      scroll: shouldScroll,
      surveyConfig: getSurveyConfigForValidate(state),
      offset: direction,
      screenerTypes: screenerTypesByQuestion[clonedQuestion.refId],
    });

    const {
      previousNodesPerNode,
      answersWithLogicFromOutcomes,
      answersWithLogicFromOutcomesHide,
      nodesWithLogicFromOutcomesShow,
      hiddenNodes,
    } = newQuestionnaireLogic;

    const updatedStateWithLogicAndNodes = Object.assign({}, state, {
      questionnaireLogic: newQuestionnaireLogic,
      surveyDetailsExtended: {
        ...state.surveyDetailsExtended,
        questions: newNodes,
      },
    });

    ({ newNodes, globalErrors } = getRevalidatedNodesAndGlobalErrors({
      nodes: newNodes,
      errors: finalGlobalErrors,
      previousNodesPerNode: mergePreviousNodesPerNode(
        state,
        LOGIC_MODE_KEYS.PLAIN,
        previousNodesPerNode,
      ),
      answersWithLogicFromOutcomes,
      answersWithLogicFromOutcomesHide,
      nodesWithLogicFromOutcomesShow,
      hiddenNodes,
      screeningQuestions,
      surveyConfig: getSurveyConfigForValidate(updatedStateWithLogicAndNodes),
    }));

    finalNodes = newNodes;
    finalQuestionnaireLogic = newQuestionnaireLogic;
    finalGlobalErrors = globalErrors;
  });

  const newState = Object.assign({}, state, {
    shouldAddEmptyQuestion: false,
    errors: finalGlobalErrors,
    questionnaireLogic: finalQuestionnaireLogic,
    surveyDetailsExtended: {
      ...state.surveyDetailsExtended,
      questions: finalNodes,
      questionnaireEditVersion: questionnaireEditVersion + 1,
    },
  });

  return validateQuotaAndUpdateState(
    setActiveNode(newState, { payload: newActiveNode }),
  );
}
